<template>
  <div class="home">
    <el-tabs
      v-model="toggleName"
      class="tabs-self-defined"
      @tab-click="handleClick"
    >
      <el-tab-pane
        v-if="toggleRepair"
        key="first"
        label="订单看板"
        name="first"
      >
        <div
          class="btngroup"
          style="margin: 0px 0 6px"
        >
          <div class="fleft">
            <div class="button-checkbox">
              <el-radio-group
                v-model="radio"
                @change="currentDayHandle"
              >
                <el-radio
                  size="small"
                  label="1"
                  border
                >
                  当日
                </el-radio>
                <el-radio
                  label="3"
                  size="small"
                  border
                >
                  当周
                </el-radio>
                <el-radio
                  label="2"
                  size="small"
                  border
                >
                  当月
                </el-radio>
                <el-radio
                  label="4"
                  size="small"
                  border
                >
                  当年
                </el-radio>
              </el-radio-group>
              <el-checkbox
                v-if="vipLevel === 1"
                v-model="isBranch"
                style="margin-left: 30px"
                @change="checkboxChange"
              >
                包含分公司
              </el-checkbox>
            </div>
          </div>
          <!-- <div
            class="fleft"
            style="padding-left: 15px"
          >
            自定义
            <el-date-picker
              v-model="orderServiceDate"
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              @change="onPickOrderServiceDate"
            />
          </div> -->
          <div class="fright">
            <a
              :href="helpSrc"
              target="_blank"
            ><el-button
              type="primary"
              size="mini"
            > 帮助中心 </el-button></a>
            <el-divider direction="vertical" />
            <el-button
              plain
              size="mini"
              style="margin-right: 10px"
              @click="fullScreen('repairHomeSrc')"
            >
              全屏显示
            </el-button>
            <el-popover
              placement="bottom"
              title="解决方案"
              width="300"
              trigger="click"
              content="如是safari浏览器，请尽量使用新版本。如是chrome谷歌浏览器: 方案一 Chrome 中打开 chrome://flags/#same-site-by-default-cookies 和 chrome://flags/#cookies-without-same-site-must-be-secure ，设置为 Disabled ，重启浏览器；方案二 降级到 Chrome 79 及以下版本，并关闭自动更新"
            >
              <el-button
                slot="reference"
                size="mini"
                plain
                type="danger"
              >
                白屏无法显示？
              </el-button>
            </el-popover>
          </div>
        </div>
        <iframe
          v-if="repairHomeSrc"
          id="repairHomeSrc"
          :src="repairHomeSrc"
          width="100%"
          :height="iframeHeight"
          frameborder="0"
        />
      </el-tab-pane>

      <el-tab-pane
        v-if="dashboardCus && toggleRepair"
        key="six"
        label="客户看板"
        name="six"
      >
        <div
          class="btngroup"
          style="margin: 0px 0 6px"
        >
          <div class="fleft">
            <div class="button-checkbox">
              <el-radio-group
                v-model="radioCus"
                @change="currentCusDayHandle"
              >
                <el-radio
                  size="small"
                  label="1"
                  border
                >
                  当日
                </el-radio>
                <el-radio
                  size="small"
                  label="2"
                  border
                >
                  当周
                </el-radio>
                <el-radio
                  size="small"
                  label="3"
                  border
                >
                  当月
                </el-radio>
                <el-radio
                  label="4"
                  size="small"
                  border
                >
                  当年
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div
            class="fleft"
            style="padding-left: 15px"
          >
            自定义
            <el-date-picker
              v-model="customerDate"
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              @change="onPickCustomerDate"
            />
          </div>
          <el-button
            type="primary"
            size="small"
            @click="handleExportCus"
          >
            导出excel
          </el-button>
          <div class="fright">
            <a
              :href="helpSrc"
              target="_blank"
            ><el-button
              type="primary"
              size="mini"
            > 帮助中心 </el-button></a>
            <el-divider direction="vertical" />
            <el-button
              plain
              size="mini"
              style="margin-right: 10px"
              @click="fullScreen('repairHomeCusSrc')"
            >
              全屏显示
            </el-button>
            <el-popover
              placement="bottom"
              title="解决方案"
              width="300"
              trigger="click"
              content="如是safari浏览器，请尽量使用新版本。如是chrome谷歌浏览器: 方案一 Chrome 中打开 chrome://flags/#same-site-by-default-cookies 和 chrome://flags/#cookies-without-same-site-must-be-secure ，设置为 Disabled ，重启浏览器；方案二 降级到 Chrome 79 及以下版本，并关闭自动更新"
            >
              <el-button
                slot="reference"
                size="mini"
                plain
                type="danger"
              >
                白屏无法显示？
              </el-button>
            </el-popover>
          </div>
        </div>
        <iframe
          v-if="repairHomeCusSrc"
          id="repairHomeCusSrc"
          :src="repairHomeCusSrc"
          width="100%"
          :height="iframeHeight"
          frameborder="0"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="dashboardDevice && toggleRepair"
        key="seven"
        label="设备看板"
        name="seven"
      >
        <div
          class="btngroup"
          style="margin: 0px 0 6px"
        >
          <el-button
            type="primary"
            size="mini"
            @click="goToStatisticsDevice"
          >
            跳转(已迁移到统计报表-设备报表)
          </el-button>
          <!-- <div class="fleft">
            <div class="button-checkbox">
              <el-radio-group
                v-model="radioDevice"
                @change="currentDeviceDayHandle"
              >
                <el-radio
                  size="small"
                  label="1"
                  border
                >
                  当日
                </el-radio>
                <el-radio
                  size="small"
                  label="2"
                  border
                >
                  当周
                </el-radio>
                <el-radio
                  size="small"
                  label="3"
                  border
                >
                  当月
                </el-radio>
                <el-radio
                  label="4"
                  size="small"
                  border
                >
                  当年
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div
            class="fleft"
            style="padding-left: 15px"
          >
            自定义
            <el-date-picker
              v-model="deviceDate"
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              @change="onPickDeviceDate"
            />
          </div>
          <el-button
            type="primary"
            size="small"
            @click="handleExportDevice"
          >
            导出excel
          </el-button>
          <div class="fright">
            <a
              :href="helpSrc"
              target="_blank"
            ><el-button
              type="primary"
              size="mini"
            > 帮助中心 </el-button></a>
            <el-divider direction="vertical" />
            <el-button
              plain
              size="mini"
              style="margin-right: 10px"
              @click="fullScreen('repairHomeDeviceSrc')"
            >
              全屏显示
            </el-button>
            <el-popover
              placement="bottom"
              title="解决方案"
              width="300"
              trigger="click"
              content="如是safari浏览器，请尽量使用新版本。如是chrome谷歌浏览器: 方案一 Chrome 中打开 chrome://flags/#same-site-by-default-cookies 和 chrome://flags/#cookies-without-same-site-must-be-secure ，设置为 Disabled ，重启浏览器；方案二 降级到 Chrome 79 及以下版本，并关闭自动更新"
            >
              <el-button
                slot="reference"
                size="mini"
                plain
                type="danger"
              >
                白屏无法显示？
              </el-button>
            </el-popover>
          </div> -->
        </div>
        <!-- <iframe
          v-if="repairHomeDeviceSrc"
          id="repairHomeDeviceSrc"
          :src="repairHomeDeviceSrc"
          width="100%"
          :height="iframeHeight"
          frameborder="0"
        /> -->
      </el-tab-pane>
      <el-tab-pane
        v-if="dashboardEngineer && toggleRepair"
        key="five"
        label="工程师看板"
        name="five"
      >
        <div
          class="btngroup"
          style="margin: 0px 0 6px"
        >
          <el-button
            type="primary"
            size="mini"
            @click="goToStatisticsEngineer"
          >
            跳转(已迁移到统计报表-工程师报表)
          </el-button>
          <!-- <div class="fleft">
            <div class="button-checkbox">
              <el-radio-group
                v-model="radioEng"
                @change="currentEngDayHandle"
              >
                <el-radio
                  size="small"
                  label="1"
                  border
                >
                  当日
                </el-radio>
                <el-radio
                  size="small"
                  label="2"
                  border
                >
                  当周
                </el-radio>
                <el-radio
                  size="small"
                  label="3"
                  border
                >
                  当月
                </el-radio>
                <el-radio
                  label="4"
                  size="small"
                  border
                >
                  当年
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div
            class="fleft"
            style="padding-left: 15px"
          >
            自定义
            <el-date-picker
              v-model="engineeDate"
              size="small"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              @change="onPickEngineeDate"
            />
          </div>
          <el-button
            type="primary"
            size="small"
            @click="handleExportEng"
          >
            导出excel
          </el-button>
          <div class="fright">
            <a
              :href="helpSrc"
              target="_blank"
            ><el-button
              type="primary"
              size="mini"
            > 帮助中心 </el-button></a>
            <el-divider direction="vertical" />
            <el-button
              plain
              size="mini"
              style="margin-right: 10px"
              @click="fullScreen('repairHomeEngSrc')"
            >
              全屏显示
            </el-button>
            <el-popover
              placement="bottom"
              title="解决方案"
              width="300"
              trigger="click"
              content="如是safari浏览器，请尽量使用新版本。如是chrome谷歌浏览器: 方案一 Chrome 中打开 chrome://flags/#same-site-by-default-cookies 和 chrome://flags/#cookies-without-same-site-must-be-secure ，设置为 Disabled ，重启浏览器；方案二 降级到 Chrome 79 及以下版本，并关闭自动更新"
            >
              <el-button
                slot="reference"
                size="mini"
                plain
                type="danger"
              >
                白屏无法显示？
              </el-button>
            </el-popover>
          </div> -->
        </div>
        <!-- <iframe
          v-if="repairHomeEngSrc"
          id="repairHomeEngSrc"
          :src="repairHomeEngSrc"
          width="100%"
          :height="iframeHeight"
          frameborder="0"
        />  -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script src="https://webapi.amap.com/ui/1.0/main.js?v=1.0.11"></script>
<script>
import {
  exportDevice,
  exportEngineer,
  exportCustomer,
  dashboardDeviceUrl,
  dashboardEngineerUrl,
  dashboardCustomerUrl,
  dashboardOrderServiceUrl,
  dashboardOrderUrl,
} from "@/api/home";
import { UserModule } from "../../store/modules/user";

import {
  checkPermissionCompany,
  checkPermissionRole,
} from "@/utils/permission";
import { Type } from "../../types/permissionType";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      // 帮助中心链接
      helpSrc: "",

      // 报修首页路径
      repairHomeSrc: "",
      repairHomeEngSrc: "",
      repairHomeCusSrc: "",
      repairHomeDeviceSrc: "",
      iframeHeight: window.innerHeight - 268,
      isBranch: true,

      //首页 first second third fourth five six
      vipLevel: 0,
      toggleName: "second",
      isFirst: true,
      dashboardEngineer: false,
      dashboardCus: false,
      dashboardDevice: false,
      toggleRepair: false,
      // baoxiu首页
      radio: "1",
      radioEng: "1",
      radioCus: "1",
      radioDevice: "1",

      orderServiceDate:[],
      engineeDate:[],
      customerDate:[],
      deviceDate:[],

    };
  },

  computed: {
  },

  mounted() {
  },

  created() {
    if (parseInt(UserModule.getCompanyId) != 0 && UserModule.company) {
      this.vipLevel = parseInt(
        String(UserModule.company.vip_level).substring(0, 1)
      );
    }
    switch (this.vipLevel) {
      case 1:
        this.helpSrc = "https://mp.weixin.qq.com/s/u8LttXNrD1hOFo2u7M3vSw";
        if (
          checkPermissionRole(
            UserModule.getCompanyId,
            Type.REPORT_ORDER_LOOK
          ) ||
          checkPermissionRole(UserModule.getCompanyId, Type.REPORT_COMPANY_LOOK)
        ) {
          this.toggleRepair = true;
        } else {
          this.toggleRepair = false;
        }
        break;
      case 2:
      case 3:
        this.helpSrc = "https://mp.weixin.qq.com/s/4pu9uuytrxEcuz-oPjIb8g";
        this.dashboardEngineer = true;
        this.dashboardCus = checkPermissionCompany(
          UserModule.getCompanyId,
          Type.CUSTOMER_COMPANY
        );
        this.toggleRepair = checkPermissionRole(
          UserModule.getCompanyId,
          Type.ORDER_LOOK_COM
        );
        this.dashboardDevice = checkPermissionCompany(
          UserModule.getCompanyId,
          Type.device
        );
        break;
    }

    this.$nextTick(function () {
      if (this.toggleRepair) {
        this.toggleName = "first";
        if (this.vipLevel === 1) {
          this.dashboardOrder(1);
        } else {
          this.dashboardOrderServiceUrl(1);
        }
      }
    });
  },
  methods: {
    goToStatisticsEngineer() {
      this.$router.push('/Statistics/engineer');
    },
    goToStatisticsDevice() {
      this.$router.push('/Statistics/device');
    },
    showErrorMsg(msg) {
      this.$notify({
        title: "提示",
        message: msg,
        offset: 100,
        type: "error",
      });
    },
    showSecussMsg(msg) {
      this.$notify({
        title: "提示",
        message: msg,
        offset: 100,
        type: "success",
      });
    },
    checkboxChange() {
      this.dashboardOrder(this.radio);
    },
    currentDayHandle() {
      this.repairHomeSrc = "";
      if (this.vipLevel === 1) {
        this.dashboardOrder(this.radio);
      } else {
        this.dashboardOrderServiceUrl(this.radio);
      }
    },
    currentEngDayHandle() {
      this.dashboardEngineerUrl(this.radioEng);
    },
    currentCusDayHandle() {
      this.dashboardCustomerUrl(this.radioCus);
    },
    currentDeviceDayHandle() {
      this.dashboardDeviceUrl(this.radioDevice);
    },
    fullScreen(ElementById) {
      let element = document.getElementById(ElementById);
      this.fullScreenElement(element);
    },
    fullScreenElement(element) {
      if (element) {
        let requestMethod =
          element.requestFullScreen ||
          element.webkitRequestFullScreen ||
          element.mozRequestFullScreen ||
          element.msRequestFullScreen;
        if (requestMethod) {
          requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") {
          var wscript = new ActiveXObject("WScript.Shell");
          if (wscript !== null) {
            wscript.SendKeys("{F11}");
          }
        }
      }
    },
    handleClick(tab, event) {
      if (this.toggleName === "second") {
        this.getMajorMonth();
      }
      if (this.toggleName === "third") {
        this.getMapData();
      }

      if (this.toggleName == "five") {
        this.dashboardEngineerUrl(this.radioEng);
      }
      if (this.toggleName == "six") {
        this.dashboardCustomerUrl(this.radioCus);
      }
      if (this.toggleName == "seven") {
        this.dashboardDeviceUrl(this.radioDevice);
      }
    },
    // 报修首页 type 1为日 2为月
    dashboardOrder(type) {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.type = type;
      pamars.contain_branch = this.isBranch ? "1" : "0";

      dashboardOrderUrl(pamars)
        .then((res) => {
          if (res && res.data) {
            this.repairHomeSrc = res.data.order_url;
          }
        })
        .catch((err) => {
          let msg = err.msg;
        });
    },
    // 内报看板 专维 订单看板
    onPickOrderServiceDate(val){
      this.radio=5
      if(val[1]-val[0]>365*24*60*60*1000){
        this.showErrorMsg('请选择365天内的时间')
        return
      }
      this.dashboardOrderServiceUrl(5)
    },
    dashboardOrderServiceUrl(type) {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.type = type;
      pamars.task_ranking_list_type = "1";
      if (this.vipLevel === 2) {
        pamars.department_ranking_list_type = "1";
      }
      if(type===5){
        pamars.diy_start_time=this.orderServiceDate[0]/1000
        pamars.diy_end_time = this.orderServiceDate[1]/1000;
      }
      pamars.fault_type_ranking_list_type = checkPermissionCompany(
        UserModule.getCompanyId,
        Type.fault
      )
        ? "1"
        : "0";
      pamars.customer_ranking_list_type = checkPermissionCompany(
        UserModule.getCompanyId,
        Type.CUSTOMER_COMPANY
      )
        ? "1"
        : "0";
      pamars.customer_trans_ranking_list_type = checkPermissionCompany(
        UserModule.getCompanyId,
        Type.CUSTOMER_COMPANY
      )
        ? "1"
        : "0";

      dashboardOrderServiceUrl(pamars)
        .then((res) => {
          if (res && res.data) {
            this.repairHomeSrc = res.data.order_service_url;
          }
        })
        .catch((err) => {
          let msg = err.msg;
        });
    },
    // 内报看板 专维 工程师看板
    // 导出工程师
    handleExportEng() {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.user_id = UserModule.getUserId;
      pamars.company_name = UserModule.getCompanyName;
      pamars.user_name = UserModule.getUserName;
      pamars.type = this.radioEng;
      pamars.sort_field = "allTaskCount";
      pamars.sort_rule = 1;
      if(this.radioEng===5){
        pamars.diy_start_time=this.engineeDate[0]/1000
        pamars.diy_end_time = this.engineeDate[1]/1000;
      }
      exportEngineer(pamars)
        .then((res) => {
          this.$confirm("跳转", "跳转", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let routeData = this.$router.resolve({
                path: "/ExportTask",
                query: {},
              });
              window.open(routeData.href);
            })
            .catch(() => {});
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    },
    onPickEngineeDate(val){
      this.radioEng=5
      if(val[1]-val[0]>365*24*60*60*1000){
        this.showErrorMsg('请选择365天内的时间')
        return
      }
      this.dashboardEngineerUrl(5)
    },
    dashboardEngineerUrl(type) {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.type = type;
      pamars.sort_field = "allTaskCount";
      pamars.sort_rule = 1;
      if(type===5){
        pamars.diy_start_time=this.engineeDate[0]/1000
        pamars.diy_end_time = this.engineeDate[1]/1000;
      }

      dashboardEngineerUrl(pamars)
        .then((res) => {
          if (res && res.data) {
            this.repairHomeEngSrc = res.data.order_url;
          }
        })
        .catch((err) => {
          let msg = err.msg;
        });
    },
    // 内报看板 专维 客户看板
    // 导出客户
    handleExportCus() {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.user_id = UserModule.getUserId;
      pamars.company_name = UserModule.getCompanyName;
      pamars.user_name = UserModule.getUserName;
      pamars.type = this.radioCus;
      pamars.sort_field = "allOrderCount";
      pamars.sort_rule = 1;
      if(this.radioCus===5){
        pamars.diy_start_time=this.customerDate[0]/1000
        pamars.diy_end_time = this.customerDate[1]/1000;
      }
      exportCustomer(pamars)
        .then((res) => {
          this.$confirm("跳转", "跳转", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let routeData = this.$router.resolve({
                path: "/ExportTask",
                query: {},
              });
              window.open(routeData.href);
            })
            .catch(() => {});
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    },
    onPickCustomerDate(val){
      this.radioCus=5
      if(val[1]-val[0]>365*24*60*60*1000){
        this.showErrorMsg('请选择365天内的时间')
        return
      }
      this.dashboardCustomerUrl(5)
    },
    dashboardCustomerUrl(type) {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.type = type;
      pamars.sort_field = "allOrderCount";
      pamars.sort_rule = 1;
      if(type===5){
        pamars.diy_start_time=this.customerDate[0]/1000
        pamars.diy_end_time = this.customerDate[1]/1000;
      }
      dashboardCustomerUrl(pamars)
        .then((res) => {
          if (res && res.data) {
            this.repairHomeCusSrc = res.data.order_url;
          }
        })
        .catch((err) => {
          let msg = err.msg;
        });
    },
    // 内报看板 专维 设备看板
    // 导出设备
    handleExportDevice() {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.user_id = UserModule.getUserId;
      pamars.company_name = UserModule.getCompanyName;
      pamars.user_name = UserModule.getUserName;
      pamars.type = this.radioDevice;
      pamars.sort_field = "task_count";
      pamars.sort_rule = 1;
      if(this.radioDevice===5){
        pamars.diy_start_time=this.deviceDate[0]/1000
        pamars.diy_end_time = this.deviceDate[1]/1000;
      }
      exportDevice(pamars)
        .then((res) => {
          this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    },
    onPickDeviceDate(val){
      this.radioDevice=5
      if(val[1]-val[0]>365*24*60*60*1000){
        this.showErrorMsg('请选择365天内的时间')
        return
      }
      this.dashboardDeviceUrl(5)
    },
    dashboardDeviceUrl(type) {
      let pamars = {};
      pamars.company_id = UserModule.getCompanyId;
      pamars.type = type;
      pamars.sort_field = "task_count";
      pamars.sort_rule = 1;
      if(type===5){
        pamars.diy_start_time=this.deviceDate[0]/1000
        pamars.diy_end_time = this.deviceDate[1]/1000;
      }
      dashboardDeviceUrl(pamars)
        .then((res) => {
          if (res && res.data) {
            this.repairHomeDeviceSrc = res.data.order_url;
          }
        })
        .catch((err) => {
          let msg = err.msg;
        });
    },
  },
};
</script>

<style lang="css">
.text-ellipsis {
  height: 2em;
  overflow: hidden;
}
.scroll_bg {
  width: 100%;
  height: 450px;
  overflow: hidden;
  position: relative;
  border: solid 1px #f5f5f5;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 0 10px;
  margin: 10px 0 20px;
}
.scroll_bg ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.scroll_bg li {
  width: 100%;
  padding: 14px 0;
  min-height: 45px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #f5f5f5;
  white-space: nowrap;
  text-overflow: clip;
}

.scroll_bg li .title {
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.countTime {
  letter-spacing: 1px;
  font-size: 12px;
  margin: 10px;
  color: #666;
}

.amap-marker-label {
  width: 25px;
  height: 25px;
  font-size: 3px;
  size: 3px;
  color: #ffffff;
  text-align: center;
  background-color: #f7534f;
  border-radius: 50%;
  border-color: #f7534f;
}
</style>
